var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CategoryListVertical container"},_vm._l((_vm.list),function(item){return _c('a',{key:item.id,staticClass:"category-item",attrs:{"href":item._link,"target":"_blank","title":item.name || item.title},on:{"click":_vm.CategoryListVerticalClick}},[_vm._v("\n    "+_vm._s(item.name || item.title)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }